import React from "react";
import SectionPage from "@/components/SectionPage";

export default function Traits() {
  return <SectionPage sectionKey="traits" />;
}
